// extracted by mini-css-extract-plugin
module.exports = {"button":"button-f37","buttonLg":"button_lg-99b","buttonMid":"button_mid-5b9","buttonSm":"button_sm-9e0"};